import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "¿Necesito experiencia?",
    a: "Puedes solicitar información sin experiencia; evaluamos el proyecto y explicamos la actividad antes de que decidas.",
  },
  {
    q: "¿Necesito seguidores?",
    a: "No para consultar. Comenzar desde cero implica desarrollar una audiencia y no garantiza ventas.",
  },
  {
    q: "¿Tengo que mostrar mi rostro?",
    a: "Se acuerda previamente. No mostrarlo no garantiza anonimato.",
  },
  {
    q: "¿Tengo que usar mis redes personales?",
    a: "No. Podemos gestionar perfiles promocionales separados dentro del alcance contratado.",
  },
  {
    q: "¿Quién administra esos perfiles?",
    a: "La agencia administra sus propias cuentas promocionales. Conservas acceso a tu cuenta de contenido y a tus reportes financieros.",
  },
  {
    q: "¿Cuánto puedo ganar?",
    a: "No existe una cifra garantizada. Depende de demanda, audiencia, contenido, constancia y condiciones de las plataformas.",
  },
  {
    q: "¿Cuánto cobra la agencia?",
    a: "El 35 % de la base neta definida en el contrato.",
  },
  {
    q: "¿Quién recibe los pagos?",
    a: "La agencia puede recibirlos como tercero autorizado si los proveedores lo permiten y posteriormente transferir tu saldo con liquidación.",
  },
  {
    q: "¿Puedo decidir mis límites?",
    a: "Sí. Se definen y registran antes de comenzar.",
  },
  {
    q: "¿Debo enviar fotografías íntimas para postular?",
    a: "No. La primera postulación no requiere contenido íntimo.",
  },
  {
    q: "¿Cuánto dura el contrato?",
    a: "Dos meses iniciales, con preaviso de 15 días para no renovar y las excepciones previstas en el contrato.",
  },
  {
    q: "¿La reunión me obliga a contratar?",
    a: "No. Es una conversación informativa.",
  },
];

export default function Preguntas() {
  return (
    <div data-testid="preguntas-page">
      <section className="py-20 lg:py-28">
        <div className="max-w-4xl mx-auto px-4 sm:px-8">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-mauve font-sans font-semibold">
              Preguntas frecuentes
            </span>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink mt-4 leading-[1.1]">
              Respuestas claras, sin letra pequeña.
            </h1>
            <p className="mt-8 text-base sm:text-lg font-light text-stone2 leading-relaxed max-w-2xl">
              Antes de postular, queremos que conozcas exactamente cómo trabajamos, qué incluye la gestión de tu
              proyecto de contenido y qué puedes esperar de nosotros.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="mt-14 border-t border-line" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-line" data-testid={`faq-item-${i + 1}`}>
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i + 1}`}
                    className="text-left font-serif text-lg sm:text-xl text-ink hover:text-mauve hover:no-underline py-6 transition-colors"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i + 1}`}
                    className="text-base font-light text-stone2 leading-relaxed pb-6"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          <Reveal>
            <p
              data-testid="faq-disclaimer"
              className="mt-12 bg-cream border border-line p-6 text-sm font-light text-stone2 leading-relaxed"
            >
              Nota importante: no prometemos ingresos garantizados ni un estilo de vida asegurado. Los resultados
              dependen de la demanda, la audiencia, el contenido, la constancia y las condiciones de cada plataforma.
            </p>
          </Reveal>

          <Reveal>
            <div className="mt-16 text-center">
              <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-ink">
                ¿Tienes otra pregunta?
              </h2>
              <Link
                to="/postula"
                data-testid="preguntas-cta-postula"
                className="mt-8 inline-flex items-center gap-2 bg-plum text-ivory hover:bg-mauve px-10 py-4 text-xs uppercase tracking-[0.18em] transition-colors duration-300 font-sans"
              >
                Solicitar una reunión <ArrowRight size={15} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
